interface H1Props {
    customStyles?: string;
    text: string;
}

export default function H1({ customStyles = "", text }: H1Props) {
    return <h1 className={`${customStyles} standard-text-color scroll-m-20 text-very-large font-heading font-semibold`}>{text}</h1>;
}
